import { defineStore } from 'pinia';
import axios from '@/api/config/axios';

export const useRedacaoStatsStore = defineStore('redacaoStatsStore', {
    state: () => ({
        estatisticas: {
            total: {
                pendentes: 0,
                corrigidas: 0,
                corrigidas_ia: 0
            },
            turmas: []
        },
        periodoAtual: 'este_mes',
        estatisticasMensais: [],
        filaCorrecoes: [],
        loading: false,
        loadingMensais: false,
        loadingFilaCorrecoes: false,
        error: null,
        errorMensais: null,
        errorFilaCorrecoes: null
    }),

    getters: {
        getTotalPendentes: (state) => state.estatisticas.total.pendentes,
        getTotalCorrigidas: (state) => state.estatisticas.total.corrigidas,
        getTotalCorrigidasIA: (state) => state.estatisticas.total.corrigidas_ia || 0,
        getTotalGeral: (state) => state.estatisticas.total.pendentes + state.estatisticas.total.corrigidas + (state.estatisticas.total.corrigidas_ia || 0),
        getEstatisticasPorTurma: (state) => state.estatisticas.turmas,
        getEstatisticasMensais: (state) => state.estatisticasMensais,
        getFilaCorrecoes: (state) => state.filaCorrecoes,
        getPeriodoAtual: (state) => state.periodoAtual,
        isLoading: (state) => state.loading,
        isLoadingMensais: (state) => state.loadingMensais,
        isLoadingFilaCorrecoes: (state) => state.loadingFilaCorrecoes
    },

    actions: {
        async fetchEstatisticas(periodo = 'este_mes') {
            this.loading = true;
            this.error = null;
            
            try {
                const response = await axios.get('/api/v1/estatisticas', {
                    params: { periodo }
                });
                
                if (response.data.success && response.data.data) {
                    this.estatisticas = {
                        total: response.data.data.total || this.estatisticas.total,
                        turmas: this.estatisticas.turmas
                    };
                    // Armazena o período retornado pela API
                    if (response.data.data.periodo) {
                        this.periodoAtual = response.data.data.periodo;
                    }
                }
                
                return response;
            } catch (error) {
                this.error = 'Erro ao buscar estatísticas das redações';
                console.error('Erro ao buscar estatísticas:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async fetchEstatisticasPorTurma() {
            this.loading = true;
            this.error = null;
            
            try {
                const response = await axios.get('/api/v1/estatisticas/turmas');
                
                if (response.data.data) {
                    this.estatisticas.turmas = response.data.data;
                }
                
                return response;
            } catch (error) {
                this.error = 'Erro ao buscar estatísticas por turma';
                console.error('Erro ao buscar estatísticas por turma:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async fetchEstatisticasMensais() {
            this.loadingMensais = true;
            this.errorMensais = null;
            
            try {
                const response = await axios.get('/api/v1/status/turmas/redacoes-mensais');
                
                if (response.data.data) {
                    this.estatisticasMensais = response.data.data;
                }
                
                return response;
            } catch (error) {
                this.errorMensais = 'Erro ao buscar estatísticas mensais das redações';
                console.error('Erro ao buscar estatísticas mensais:', error);
                throw error;
            } finally {
                this.loadingMensais = false;
            }
        },

        async fetchFilaCorrecoes() {
            this.loadingFilaCorrecoes = true;
            this.errorFilaCorrecoes = null;
            
            try {
                const response = await axios.get('/api/v1/fila-correcoes');
                
                if (response.data.success && response.data.data) {
                    this.filaCorrecoes = response.data.data;
                }
                
                return response;
            } catch (error) {
                this.errorFilaCorrecoes = 'Erro ao buscar fila de correções';
                console.error('Erro ao buscar fila de correções:', error);
                throw error;
            } finally {
                this.loadingFilaCorrecoes = false;
            }
        }
    }
}); 